module.exports = __webpack_public_path__ + "static/media/facebook_icon.0361a6a0.svg";